// src/pages/products/CreateProduct.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditProduct from "../../components/products/FormAddEditProduct";

const CreateProduct = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/products");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProduct
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateProduct;
